import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import * as myGlobals from './../global';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Ciudad } from './ciudad';
import { throwError } from 'rxjs';
import { HttpClientSecured } from '../services/http-client-secured';

@Injectable({
  providedIn: 'root'
})
export class CiudadesService {
  private _ciudadesURL = myGlobals.baseApi + '/webadmin/v1/cities';

  constructor(private http: HttpClientSecured) {}

  allRecords() {
    return this.http.get<any>(this._ciudadesURL);
  }

  getBusiness(itemid: number): Observable<Ciudad | undefined> {
    return this.allRecords().pipe(map((ciudades: Ciudad[]) => ciudades.find(p => p.id === itemid)));
  }
}
